import * as Anchors from "./anchors";

export default {
  Anchors,
};
